import { Skeleton, TableBody, TableCell, TableRow } from '@mui/material'

export const TableSkeleton = ({ noOfRows, noOfCols }: { noOfRows: number; noOfCols: number }) => (
  <TableBody>
    {new Array(noOfRows).fill(0).map((_, index) => (
      <TableRow key={`${index}-skeleton`}>
        {new Array(noOfCols).fill(0).map((_, colIndex) => (
          <TableCell key={`${index}-${colIndex}-skeleton`}>
            <Skeleton variant="text" height={30} sx={{ maxWidth: 100 }} />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </TableBody>
)
